module.exports = __webpack_public_path__ + "static/media/meFaded.45e016f6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/view/global/assets/meFaded.jpg
// module id = 87
// module chunks = 0